<template>
  <div>
    <div class="row justify-content-between">
      <div class="col-5">
        <report-type-selector
          :report-type-selected="getSelectedReportType"
          :buttons="buttons"
          @clicked="onClickReportTypeHandler"
        ></report-type-selector>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 pr-0">
        <dashboard-report-filter v-model="filterText"></dashboard-report-filter>
      </div>
    </div>

    <div class="row">
      <div class="col-12 p-0 mt-3">
        <div class="dropdown-divider mt-0 pb-2 w-102 mb-4 ml-n5 mr-n5"></div>
      </div>
    </div>

    <div class="row flip-cards-container">
      <square-option
        v-for="(option, index) in filteredMenuOptions"
        :key="index"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { name as userModuleName } from '@/modules/user/store'
import { name as commonModuleName } from '@/modules/common/store'
import squareOption from '@/components/common/menu/SquareOption'
import ReportTypeSelector from '@/components/common/menu/ReportTypeSelector'
import DashboardReportFilter from '@/components/common/menu/DashboardReportFilter'
import { DASHBOARD_ROOT_NAV_MENU_ID, REPORTS_TYPE } from '@/config.js'

export default {
  name: 'DashboardReportMenu',
  components: {
    squareOption,
    ReportTypeSelector,
    DashboardReportFilter,
  },
  props: {},
  data() {
    return {
      filterText: null,
      
    }
  },
  computed: {
    filteredMenuOptions() {
      let allItems = this.selectedMenuItem?.filter((e) =>
        e.route.includes(this.getSelectedReportType)
      )
      const filteredItems = this.filterText
        ? allItems?.filter((e) =>
            e.title.toLowerCase().match(this.filterText.toLowerCase())
          )
        : allItems;

      //agregar custom sort para los cards pertenecientes a Informe de Progreso (Estipulaciones)
      if(this.getSelectedReportType === REPORTS_TYPE.PROGRESS){
        return filteredItems.sort((a, b)=>{
          return a.sortOrder - b.sortOrder
        });
      }

      return filteredItems;
    },
    isFilterVisible() {
      return this.HasReports || this.HasDashboards
    },
    isSelectorVisible() {
      return this.HasReports && this.HasDashboards
    },
    HasReports() {
      return this.selectedMenuItem?.some((x) =>
        x.route.match(`/${REPORTS_TYPE.REPORT}`)
      )
    },
    HasDashboards() {
      return this.selectedMenuItem?.some((x) =>
        x.route.match(`/${REPORTS_TYPE.DASHBOARD}`)
      )
    },
    HasEden() {
      return this.selectedMenuItem?.some((x) =>
        x.route.match(`/${REPORTS_TYPE.EDEN}`)
      )
    },
    HasProgress() {
      return this.selectedMenuItem?.some((x) =>
        x.route.match(`/${REPORTS_TYPE.PROGRESS}`)
      )
    },
    buttons(){return [
        {
          reportType: REPORTS_TYPE.REPORT,
          text: 'Informes',
          icon: 'fa fa-file-chart-line',
          enabled:this.HasReports
        },
        {
          reportType: REPORTS_TYPE.DASHBOARD,
          text: 'Dashboard',
          icon: 'fa fa-chart-pie',
          enabled:this.HasDashboards
        },
        {
          ...(this.HasEden && {
            reportType: REPORTS_TYPE.EDEN,
            text: "EDEN",
            icon: "fa fa-file-alt",
            enabled: this.HasEden,
          }),
        },
        {
          ...(this.HasProgress && {
            reportType: REPORTS_TYPE.PROGRESS,
            text: "Informes de Progreso",
            icon: "fa fa-sync-alt",
            enabled: this.HasProgress,
          }),
        },
      ]},
    ...mapGetters(userModuleName, ['selectedMenuItem']),
    ...mapGetters(commonModuleName, ['getSelectedReportType']),
  },
  mounted() {
    this.setMenuItemId({ id: DASHBOARD_ROOT_NAV_MENU_ID })

    //ECG:auto select if user has access to a single type of report
    if (this.HasReports && !this.HasDashboards) {
      this.setSelectedReportType(REPORTS_TYPE.REPORT)
    } else if (!this.HasReports && this.HasDashboards) {
      this.setSelectedReportType(REPORTS_TYPE.DASHBOARD)
    //ECG:select informes by default if user has access to both types
    } else if (
      this.HasReports &&
      this.HasDashboards &&
      this.getSelectedReportType == ''
    ) {
      this.setSelectedReportType(REPORTS_TYPE.REPORT)
    }
  },
  methods: {
    onClickReportTypeHandler(reportTypeSelected) {
      this.setSelectedReportType(reportTypeSelected)
    },
    ...mapActions(userModuleName, ['setMenuItemId']),
    ...mapActions(commonModuleName, ['setSelectedReportType']),
  },
}
</script>
